import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, numberAttribute } from '@angular/core';
import { hlm } from '@spartan-ng/brain/core';
import { NgxSonnerToaster, type ToasterProps } from 'ngx-sonner';

import type { ClassValue } from 'clsx';

@Component({
    selector: 'hlm-toaster',
    imports: [ NgxSonnerToaster ],
    template: `
        <ngx-sonner-toaster
            [class]="_computedClass()"
            [invert]="invert()"
            [theme]="theme()"
            [position]="position()"
            [hotKey]="hotKey()"
            [richColors]="richColors()"
            [expand]="expand()"
            [duration]="duration()"
            [visibleToasts]="visibleToasts()"
            [closeButton]="closeButton()"
            [toastOptions]="toastOptions()"
            [offset]="offset()"
            [dir]="dir()"
            [style]="userStyle()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HlmToasterComponent {
    public readonly invert = input<ToasterProps['invert'], boolean | string>(false, {
        transform: booleanAttribute
    });
    public readonly theme = input<ToasterProps['theme']>('light');
    public readonly position = input<ToasterProps['position']>('bottom-right');
    public readonly hotKey = input<ToasterProps['hotkey']>([ 'altKey', 'KeyT' ]);
    public readonly richColors = input<ToasterProps['richColors'], boolean | string>(false, {
        transform: booleanAttribute
    });
    public readonly expand = input<ToasterProps['expand'], boolean | string>(false, {
        transform: booleanAttribute
    });
    public readonly duration = input<ToasterProps['duration'], number | string>(4000, {
        transform: numberAttribute
    });
    public readonly visibleToasts = input<ToasterProps['visibleToasts'], number | string>(3, {
        transform: numberAttribute
    });
    public readonly closeButton = input<ToasterProps['closeButton'], boolean | string>(false, {
        transform: booleanAttribute
    });
    public readonly toastOptions = input<ToasterProps['toastOptions']>({
        classes: {
            toast:
                'tw-group toast group-[.toaster]:tw-bg-background group-[.toaster]:tw-text-foreground group-[.toaster]:tw-border-border group-[.toaster]:tw-shadow-lg',
            description: 'group-[.toast]:tw-text-muted-foreground',
            actionButton: 'group-[.toast]:tw-bg-primary group-[.toast]:tw-text-primary-foreground',
            cancelButton: 'group-[.toast]:tw-bg-muted group-[.toast]:tw-text-muted-foreground'
        }
    });
    public readonly offset = input<ToasterProps['offset']>(null);
    public readonly dir = input<ToasterProps['dir']>('auto');
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    public readonly userStyle = input<Record<string, string>>({}, { alias: 'style' });

    protected readonly _computedClass = computed(() => hlm('toaster tw-group', this.userClass()));
}
